
import { Button } from "@/components/ui/button";

interface FormActionsProps {
  isAuthenticated: boolean;
  isLoading: boolean;
}

export function FormActions({ isAuthenticated, isLoading }: FormActionsProps) {
  // Debug log per aiutare a diagnosticare problemi futuri
  console.log("[FormActions] Button state:", { 
    isAuthenticated, 
    isLoading, 
    buttonDisabled: !isAuthenticated || isLoading 
  });
  
  return (
    <div>
      <Button 
        type="submit" 
        className="w-full"
        disabled={!isAuthenticated || isLoading}
      >
        {isLoading ? 'Creazione...' : 'Crea Avviso'}
      </Button>
      
      {!isAuthenticated && (
        <p className="text-sm text-center text-muted-foreground mt-2">
          Devi effettuare l'accesso per creare avvisi di prezzo
        </p>
      )}
    </div>
  );
}
